module.exports = __webpack_public_path__ + "assets/img/pegi-pt.6f8c1bbc.png";